import SustainabilityPage from './SustainabilityPage';

export default SustainabilityPage;
